import { emptyObject } from '@constants/empty';
/* eslint-disable import/prefer-default-export */
const processSolutionData = (solutionData = {}) => {
  if (!solutionData) return emptyObject;
  if (solutionData.processed) return solutionData;
  const data = {
    ...solutionData,
    processed: true,
    positiveFeedback:
      solutionData.positive_feedback || solutionData.positiveFeedback,
    userFeedback: solutionData.user_feedback || solutionData.userFeedback,
    shouldAskForFeedback:
      solutionData.should_ask_for_feedback || solutionData.shouldAskForFeedback,
    generalFeedback:
      solutionData.general_feedback || solutionData.generalFeedback,
    isWatched: solutionData.is_watched || solutionData.isWatched,
    objectType: solutionData.object_type || solutionData.objectType
  };
  return data;
};

export const processCustomDoubtDetails = (
  data = {},
  isSelectedReset = true
) => {
  if (data.processed) return data;
  const newData = {
    ...data,
    isSelectedReset,
    processed: true,
    asdState: data?.asd_state,
    askToEducator: data?.ask_to_educator,
    allowSubjectUpdate: data?.allow_subject_update,
    ocrText: data?.ocr_text,
    doubtOwnerUID: data?.learnerId || data?.learner_id,
    solutions:
      data?.solutions?.map((solution) => processSolutionData(solution)) || []
  };
  return newData;
};

export const processDoubtConfig = (data = {}) => {
  const newData = {
    preferredLanguage: data.preferred_language,
    isASDEnabled: data.is_asd_enabled_on_web,
    isAadAvailable: data.is_aad_available,
    didUserAskFirstDoubt: data.did_user_ask_first_doubt,
    sample: data.sample,
    samples: data.samples,
    allowedToAskNewDoubt: data.allowed_to_ask_new_doubt,
    dailyRemainingDoubtsCount: data.daily_remaining_doubts_count,
    dailyTotalDoubtsCount: data.daily_total_doubts_count,
    dailyRemainingOpenDoubtsCount: data.daily_remaining_open_doubts_count,
    dailyTotalOpenDoubtsCount: data.daily_total_open_doubts_count,
    maxAttachmentSizeInKB: data.max_attachment_size_kb,
    is_asd_enabled: data.is_asd_enabled,
    askPreferredLanguage: data.ask_preferred_language,
    isAiDoubtsEnabled: data.is_ai_doubts_enabled,
    ...data
  };
  return newData;
};
